import type { TabChangedPage } from '../events'
import { trackAnalyticsEvent } from '../track'

interface TrackTabChangedParams {
  page: TabChangedPage
  tab: string
  entityId: string | undefined
  /** Undefined when the route segment isn't a chain the interface deploys on. */
  chainId: number | undefined
}

/**
 * Fired when a user clicks a tab on a market or vault page. Only the click path
 * is instrumented — the scroll-spy and deep-link paths move the active tab
 * without going through the tab bar's `onChange`, and counting those would
 * conflate scrolling with deliberate navigation.
 */
export function trackTabChanged({ page, tab, entityId, chainId }: TrackTabChangedParams) {
  trackAnalyticsEvent('tab_changed', {
    page,
    tab,
    ...(entityId && { entity_id: entityId }),
    ...(chainId !== undefined && { chain_id: chainId })
  })
}
